<template>
  <base-extra :extra="extra" class="extra">
    <template #select>
      <div class="ui-select">
        <span class="caret"><span class="l" /> <span class="r" /></span>
        <select
          data-test="extra-choice-select"
          :data-extra-id="extra.id"
          :data-extra-name="extra.name"
          :data-test-value="selectedCounter"
          :value="selectedCounter"
          @change.prevent="
            $emit('input', {
              extraId: extra.id,
              quantity: Number($event.target.value),
            })
          "
        >
          <option v-for="option of selectOptions" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>
    </template>
    <template #price>
      <pu-price
        :price="getExtraTotal(extra.price, selectedCounter)"
        :display-original-price="true"
      />
    </template>
  </base-extra>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SimpleMoney, simpleMoneyToMoney } from '../../../../utility/money'
import type { Extra } from '../../schema'

@Component({
  emits: ['input'],
})
class ExtraChoice extends Vue {
  @Prop({ required: true })
  extra: Extra

  @Prop({ default: 0 })
  selectedCounter: number

  get isUnlimited() {
    return this.extra.max === null || this.extra.max === Infinity
  }

  get selectOptions(): number[] {
    return [...Array(this.getExtraMax() + 1).keys()]
  }

  private getExtraMax(): number {
    let max = this.extra.max
    if (this.isUnlimited) {
      max = 30
    }
    return max
  }

  getExtraTotal(price: SimpleMoney, quantity: number) {
    return simpleMoneyToMoney(price).multiply(quantity)
  }
}

export default toNative(ExtraChoice)
</script>

<style scoped>
.extra :deep(.max) {
  color: var(--colour-text-light);
  font-size: var(--body);
}

.extra :deep(.max::before) {
  content: '\a';
  white-space: pre;
}

.ui-select {
  width: auto;
  display: inline-block;
}

.ui-select :deep(select) {
  width: auto;
}
</style>
